import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledDivComponent } from '../types';
import { Icon } from './Icon';

export const Logo: StyledDivComponent = styled.div`
  display: block;
  margin: 25px 0;
  max-width: 300px;

  @media print {
    margin: 0 0 40px 25px;
  }

  ${Icon} {
    display: block;
    width: auto;
    height: auto;

    svg {
      width: auto;
      height: auto;
      fill: ${(props: ThemeProps<Theme>) =>
        props.theme.colors.black} !important;
    }

    canvas,
    svg {
      @media print {
        width: 150px;
      }
    }
  }
`;
